export default "__VITE_ASSET__c0dfe974__"